import i18next from 'i18next';

/*******************************************************
 * Hierarchy business rules:
 * The parameter "hierarchy" contains the collection of levels, and "newLevel" is the updated level coming from UI;
 * Logic:
 * The level from collection with same number as newLevel is replaced by a clean form of newLevel;
 * For the levels from collection with number bigger than newLevel the properties "id" and "name" are cleaned;
 * For any other level from collection nothing is changed;
 *******************************************************/

const applyHierarchyBusinessRules = (hierarchy, newLevel) => {
  const newHierarchy = hierarchy.map(function (level) {
    const updatedLevelNo = newLevel.level;
    if (level.level === updatedLevelNo) return cleanLevel(newLevel);
    else if (level.level > updatedLevelNo) return { ...level, id: null, name: null };
    else return level;
  });
  return newHierarchy;
};

export const applyHierarchyValidationRules = (hierarchy, isFacilityFrame = false) => {
  hierarchy?.forEach(level => {
    if (hierarchyLevelIsEmpty(level) && (!isFacilityFrame || level.level === 1)) {
      level.error = i18next.t('Validations.Generic.Mandatory');
    }
  });
  return hierarchy;
};

const cleanLevel = lvl => {
  const { id, name, level, triggers, error } = lvl;
  return { id, name, level, triggers, error };
};

export const applyHierarchyRules = (hierarchy, newLevel, ignoreValidation) => {
  const hierarchyAfterBusinessRules = applyHierarchyBusinessRules(hierarchy, newLevel);

  if (ignoreValidation) return hierarchyAfterBusinessRules;

  return applyHierarchyValidationRules(hierarchyAfterBusinessRules);
};

export const hierarchyLevelIsEmpty = level => level.id === null && level.name === null;

export const hierarchyIsValid = hierarchy => {
  if (!hierarchy) return false;
  return hierarchy.filter(z => z.error && z.error !== '').length === 0;
};
